import script from "./AddLinkedUserFieldGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLinkedUserFieldGroup.vue?vue&type=script&setup=true&lang=js"

import "./AddLinkedUserFieldGroup.vue?vue&type=style&index=0&id=2f32ee67&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f32ee67"]])

export default __exports__